import { isToday, isTuesday } from 'date-fns/esm'
import { useConfig } from '../core/config'
import { useToast } from '../core/elements/toast'
import { useLocalState } from '../utils/persistence'

export function installUpdateNotifier() {
  if (import.meta.env.DEV) return

  const config = useConfig()
  const toast = useToast()
  const state = useLocalState('update-notifier-state', {
    notified: false,
    notifiedAt: new Date().getTime(),
  })

  function notify() {
    toast.show({
      type: 'stella',
      severity: 'info',
      message:
        'We’ve made some updates and improvements! Please refresh the page to get the best of the best. (You deserve nothing less.)',
      action: {
        type: 'button',
        label: 'Refresh',
        handler() {
          window.location.reload()
        },
      },
    })
    state.notified = true
    state.notifiedAt = new Date().getTime()
  }

  async function isFresh() {
    try {
      const res = await fetch('/__internal/info')
      const data = await res.json()

      return data.version === config.version
    } catch {
      // We couldn't verify the freshness of the version, as the fetch failed for some reason.
      // Let's assume it's still fresh and we can verify again in the next cycle
      return true
    }
  }

  async function check() {
    if (state.notified) {
      if (isToday(state.notifiedAt)) return
      if (!isTuesday(new Date())) return
      state.notified = false
    }

    if (await isFresh()) return

    notify()
  }

  async function run() {
    await check()

    // a check every hour
    setTimeout(run, 60 * 60 * 1000)
  }

  run()
}
